import createSetParams from './setParams';
import { paramsVar } from '../reactiveVariables';

const setParams = createSetParams(paramsVar);

export default setParams;
